import axios, { AxiosResponse } from 'axios'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import { IClient, IPhone, IClientResponse } from 'safe'
import {
  ClientTypes,
  SET_CLIENTS,
  SET_CLIENT,
  UPDATE_CLIENT,
  DELETE_CLIENT,
  ENABLE_CLIENT,
  UPDATE_CREDIT,
  DELETE_DOCUMENT_CLIENT,
  ADD_DOCUMENT_CLIENT,
} from './actionTypes'

const server = process.env.REACT_APP_SERVER_URL

const setClients = (clientsData: IClientResponse): ClientTypes => ({
  type: SET_CLIENTS,
  payload: clientsData,
})
const setClient = (client: IClient): ClientTypes => ({
  type: SET_CLIENT,
  payload: client,
})
const editClient = (client: IClient): ClientTypes => ({
  type: UPDATE_CLIENT,
  payload: client,
})
const deleteClient = (client: IClient): ClientTypes => ({
  type: DELETE_CLIENT,
  payload: client,
})

const enableClient = (id: string, enable: boolean): ClientTypes => ({
  type: ENABLE_CLIENT,
  payload: { id, enable },
})

const updateCredit = (id: string, credit: any): ClientTypes => ({
  type: UPDATE_CREDIT,
  payload: { id, credit },
})

const deleteDocumentClientType = (
  id: string,
  clientId: string
): ClientTypes => ({
  type: DELETE_DOCUMENT_CLIENT,
  payload: { id, clientId },
})

const addDocumentClient = (
  clientId: number,
  document: { id: string; url: string }
): ClientTypes => ({
  type: ADD_DOCUMENT_CLIENT,
  payload: {
    clientId,
    document,
  }
})

export const fetchClients = (
  querySearch: string[] = [],
  paginationParams: string[]
): ThunkAction<Promise<void>, {}, {}, ClientTypes> => async (
  dispatch: ThunkDispatch<{}, {}, ClientTypes>
): Promise<void> => {
  try {
    // console.log("idx", index)
    // const response: AxiosResponse<{
    //   status: number
    //   clients: IClient[]
    //   numberOfPages: number
    // }> = await axios.get(
    //   `${server}/thirdparty/client?${[...querySearch, ...paginationParams].join(
    //     '&'
    //   )}`
    // )

    const response = await axios.get(`${server}/thirdparty/client?${[...querySearch, ...paginationParams].join("&")}`)

    console.log("response...", response)

    dispatch(
      setClients({
        clients: response.data.clients.map(v => ({...v, address: {
          address: v.address,
          city: v.city,
          state: v.state,
          postalCode: v.postalCode
        }})),
        numberOfPages: response.data.numberOfPages,
      })
    )
  } catch (e) {
    throw e
  }
}

export const createClient = (
  client: any,
  hasImage: boolean = false,
  fd: FormData = new FormData(),
): ThunkAction<Promise<void>, {}, {}, ClientTypes> => async (
  dispatch: ThunkDispatch<{}, {}, ClientTypes>
): Promise<any> => {
  console.log("llega a eta funcion", client)

  try {
    // const parsedPhones = client.client.phones.map((phone: IPhone) => ({
    //   ...phone,
    //   id: Number(phone.id),
    // }))
    const response: AxiosResponse<{
      status: number
      newClient: IClient
    }> = await axios.post(`${server}/thirdparty/client`, client)

    if (hasImage) {
      try {
        const response2: AxiosResponse<any> = await axios.put(
          `${server}/media/file?idEntity=${response.data.newClient.id}&entity=client`,
          fd
        )
        // setTimeout(() => {
        //   cb && cb("Imagen subida satisfactoriamente", "success")
        // }, 5000)
      } catch (err) {
        // cb && cb("Error al subir imagen", "error")
        throw err
      }
    }
    return response

    // dispatch(setClient(response.data.newClient))
  } catch (e) {
    throw e
  }
}

export const updateClient = (
  client: {
    client: IClient
  },
  hasImage: boolean = false,
  fd: FormData = new FormData()
): ThunkAction<Promise<void>, {}, {}, ClientTypes> => async (
  dispatch: ThunkDispatch<{}, {}, ClientTypes>
): Promise<void> => {
  console.log("CLIENT", client)
  try {
    const response: AxiosResponse<{
      status: number
      client: IClient
    }> = await axios.patch(`${server}/thirdparty/client`, {
      ...client,
    })
    // const newClient = response.data.client
    // dispatch(editClient(newClient))
    // if (hasImage) {
    //   try {
    //     const response2: AxiosResponse<any> = await axios.put(
    //       `${server}/media/file?idEntity=${newClient.id}&entity=client`,
    //       fd
    //     )
    //     dispatch(
    //       addDocumentClient(newClient.id, {
    //         id: response2.data.file.id,
    //         url: response2.data.file.url,
    //       })
    //     )
    //   } catch (err) {
    //     throw err
    //   }
    // }
  } catch (e) {
    throw e
  }
}

export const removeClient = (
  client: IClient
): ThunkAction<Promise<void>, {}, {}, ClientTypes> => async (
  dispatch: ThunkDispatch<{}, {}, ClientTypes>
): Promise<void> => {
  try {
    await axios.delete(`${server}/thirdparty/client?id=${client.id}`)
    dispatch(deleteClient(client))
  } catch (e) {
    throw e
  }
}

export const onEnableClient = (
  id: string,
  enable: boolean
): ThunkAction<Promise<void>, {}, {}, ClientTypes> => async (
  dispatch: ThunkDispatch<{}, {}, ClientTypes>
): Promise<void> => {
  try {
    let response = await axios.patch(
      `${server}/thirdparty/client`,
      { id, enable }
    )
    dispatch(enableClient(id, enable))
  } catch (e) {
    throw e
  }
}

export const onUpdateCredit = (
  id: string,
  credit: any
): ThunkAction<Promise<void>, {}, {}, ClientTypes> => async (
  dispatch: ThunkDispatch<{}, {}, ClientTypes>
): Promise<void> => {
  try {
    let response = await axios.patch(
      `${server}/thirdparty/client/${id}/credit`,
      credit
    )
    dispatch(updateCredit(id, response.data.addedCredit.credit))
  } catch (e) {
    throw e
  }
}

export const deleteDocumentClient = (
  id: string,
  url: string,
  clientId: string
): ThunkAction<Promise<void>, {}, {}, ClientTypes> => async (
  dispatch: ThunkDispatch<{}, {}, ClientTypes>
): Promise<void> => {
  try {
    let response = await axios.put(
      `${server}/media/delete-file?idEntity=${id}&entity=client`,
      {
        originalname: url,
      }
    )
    dispatch(deleteDocumentClientType(id, clientId))
  } catch (e) {
    throw e
  }
}
